import React from 'react';
import background from '../../assets/flatworm.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoFlatworm extends React.Component {
  render () {
    return(


    <ReusableInfoCard     

    tag="OCEANS"
    subtag="INVASIVE PARASITE"
    description="Flatworm"
        
    paragraph="Flatworm, also known as Amakusaplana acroporae, is a parasite that has been identifiied at the Great Barrier Reef. The flatworm infects a type of staghorn coral known as acropora, a vital component of reefs. "
    
    background= {background}
    />
  
  );
 }
}
export default InfoFlatworm;